import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=45e2b55c&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=js"
export * from "./MobileMenu.vue?vue&type=script&lang=js"
import style0 from "@/assets/pages/menu/styles/index.response.css?vue&type=style&index=0&id=45e2b55c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e2b55c",
  null
  
)

export default component.exports